import { servicePromotionRepository } from "@/repositories/Index";

class ServicePromotionService {
  //精准营销-订单操作记录
  async getBrandAdModeFn() {
    const res = await servicePromotionRepository.getBrandAdMode();
    return res;
  }

  async getBrandAdTimeIntervalFn() {
    const res = await servicePromotionRepository.getBrandAdTimeInterval();
    return res;
  }

  async createBrandAdOrderFn(params: any) {
    const res = await servicePromotionRepository.createBrandAdOrder(params);
    return res;
  }

  async toPaymentFn(params: any) {
    const res = await servicePromotionRepository.toPayment(params);
    return res;
  }




  async getIntelligentRecommendationAdMode(params?: any) {
    const res = await servicePromotionRepository.getIntelligentRecommendationAdMode(params);
    return res;
  }

  async getIntelligentRecommendationTimeInterval(params?: any) {
    const res = await servicePromotionRepository.getIntelligentRecommendationTimeInterval(params);
    return res;
  }

  async createIntelligentRecommendationOrderFn(params: any) {
    const res = await servicePromotionRepository.createIntelligentRecommendationOrder(params);
    return res;
  }

  // 获取投放位置和帧数
  async wxcanapplySeatFn() {
    const res = await servicePromotionRepository.wxcanapplySeat();
    return res;
  }

  // 微信达人按期数、位置获取价格信息
  async wxpriceInfosFn(params: any) {
    const res = await servicePromotionRepository.wxpriceInfos(params);
    return res;
  }

  // 微信达人-下单接口
  async wechatCreateFn(params: any) {
    const res = await servicePromotionRepository.wechatCreate(params);
    return res;
  }


  //获取相似酒店订单基本信息
  async similarRecommendFn(params: any) {
    const res = await servicePromotionRepository.similarRecommend(params);
    return res;
  }

  //获取相似酒店价格计划
  async similarPricePlanFn(params: any) {
    const res = await servicePromotionRepository.similarPricePlan(params);
    return res;
  }

  // 翻译中文接口
  async translateChineseContentFn(params: any) {
    const res = await servicePromotionRepository.translateChineseContent(params);
    return res;
  }

  //获取相似酒店目标酒店
  async similarTargetHotelFn(params: any) {
    const res = await servicePromotionRepository.similarTargetHotel(params);
    return res;
  }

  // 查询程艺推荐等级
  async getDecorateGradeFn(params: any) {
    const res = await servicePromotionRepository.getDecorateGrade(params);
    return res;
  }

  // 程艺推荐售卖的日期接口
  async shopDecorateRateplanFn(params: any) {
    const res = await servicePromotionRepository.shopDecorateRateplan(params);
    return res;
  }

  // 创建程艺推荐
  async createDecorateFn(params: any) {
    const res = await servicePromotionRepository.createDecorate(params);
    return res;
  }

  // 分页获取订单信息
  async getPageOrderFn(params: any) {
    const res = await servicePromotionRepository.getPageOrder(params);
    return res;
  }
  //获取即将过期订单提醒数据
  async getOrderNoticeSumFn(params: any) {
    const res = await servicePromotionRepository.getOrderNoticeSum(params);
    return res;
  }

  //获取即将过期订单列表
  async getOrderNoticeListFn(params: any) {
    const res = await servicePromotionRepository.getOrderNoticeList(params);
    return res;
  }

  //订单详情
  async getOrderDetailFn(params: any) {
    const res = await servicePromotionRepository.getOrderDetail(params);
    return res;
  }
  //取消订单
  async toCancelOrderFn(params: any) {
    const res = await servicePromotionRepository.toCancelOrder(params);
    return res;
  }

  //获取流量快车运营数据
  async getFlowFlashIndustryFn(params: any) {
    const res = await servicePromotionRepository.getFlowFlashIndustry(params);
    return res;
  }

  //获取新的数据报告
  async getDataReportFn(params: any) {
    const res = await servicePromotionRepository.getDataReport(params);
    return res;
  }
  //市场大促活动配置列表
  async findMarketPromotionConfigFn(params: any) {
    const res = await servicePromotionRepository.findMarketPromotionConfig(params);
    return res;
  }

  //市场活动-创建订单
  async orderCreateFn(params: any) {
    const res = await servicePromotionRepository.orderCreate(params);
    return res;
  }

  //创建相似酒店推荐
  async createAlikeFn(params: any) {
    const res = await servicePromotionRepository.createAlike(params);
    return res;
  }

  async getCommonConfig() {
    const res = await servicePromotionRepository.getCommonConfig();
    return res;
  }


}

export default ServicePromotionService;